import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css';
import { defineComponent, inject, ref, onMounted, onUnmounted, watch, getCurrentInstance, openBlock, createBlock, withDirectives, createVNode, vShow, renderSlot, reactive, toRefs, toRef, provide, pushScopeId, popScopeId, withScopeId, resolveComponent, withCtx } from 'vue';
import Deferred from 'my-deferred/dist/src';
import mapboxgl, { Marker, GeoJSONSource } from 'mapbox-gl';
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
import Deferred$1 from 'my-deferred';
import equal from 'fast-deep-equal';
import MapboxDrawControl from '@mapbox/mapbox-gl-draw';
import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css';
import 'mapbox-gl/dist/mapbox-gl.css';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

var slotIsNotEmpty = function (el) {
    return el && el.outerHTML !== '<div></div>';
};
var filterObject = function (object, keys, blacklist) {
    if (blacklist === void 0) { blacklist = [undefined]; }
    var result = {};
    var _keys = keys || Object.keys(object);
    var _loop_1 = function (key) {
        if (!blacklist.some(function (b) { return b === object[key]; })) {
            result[key] = object[key];
        }
    };
    for (var _i = 0, _keys_1 = _keys; _i < _keys_1.length; _i++) {
        var key = _keys_1[_i];
        _loop_1(key);
    }
    return result;
};
var parentsNameIs = function (instance, parentName) {
    if (!instance.parent)
        return false;
    // Vue 3
    if (instance.parent.type)
        return instance.parent.type.name === parentName;
    // Vue 2
    if (instance.parent.vnode.tag)
        return instance.parent.vnode.tag.endsWith(parentName);
    return false;
};
var parentNameContains = function (instance, parentNameFragment) {
    if (!instance.parent)
        return false;
    // Vue 3
    if (instance.parent.type)
        return instance.parent.type.name.includes(parentNameFragment);
    // Vue 2
    if (instance.parent.vnode.tag)
        return instance.parent.vnode.tag.includes(parentNameFragment);
    return false;
};
var duplicateEvents = function (object, instance, events) {
    var _loop_2 = function (event_1) {
        object.on(event_1, function (evt) {
            instance.emit(event_1, evt);
        });
    };
    for (var _i = 0, events_1 = events; _i < events_1.length; _i++) {
        var event_1 = events_1[_i];
        _loop_2(event_1);
    }
};

var mountGeocoderControl = function (vmb_map, vmb_geocoder, props, instance) { return __awaiter(void 0, void 0, void 0, function () {
    var map, _a, options, geocoder;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!vmb_map) return [3 /*break*/, 2];
                return [4 /*yield*/, vmb_map.promise];
            case 1:
                _a = _b.sent();
                return [3 /*break*/, 3];
            case 2:
                _a = null;
                _b.label = 3;
            case 3:
                map = _a;
                options = getGeocoderControlOptions(props);
                geocoder = new MapboxGeocoder(options);
                if (parentsNameIs(instance, 'MapboxMap') && map)
                    map.addControl(geocoder);
                else {
                    if (instance.parent)
                        geocoder.addTo(instance.refs.geocoder);
                    if (slotIsNotEmpty(instance.refs['custom-input'])) {
                        attachToInput(instance.refs['custom-input'], geocoder, instance);
                    }
                }
                window.MapboxGeocoder = MapboxGeocoder;
                window.geocoder = geocoder;
                vmb_geocoder.resolve(geocoder);
                return [2 /*return*/];
        }
    });
}); };
var mountGeocoderEvents = function (vmb_geocoder, instance) { return __awaiter(void 0, void 0, void 0, function () {
    var geocoder;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, vmb_geocoder.promise];
            case 1:
                geocoder = _a.sent();
                geocoder.on('result', function (res) {
                    instance.emit('result', res.result);
                    instance.proxy.geocoderState.result = res.result;
                });
                geocoder.on('results', function (res) {
                    instance.emit('results', res);
                    instance.proxy.geocoderState.results = res;
                });
                geocoder.on('error', function (err) {
                    instance.emit('error', err);
                    instance.proxy.geocoderState.error = err;
                });
                geocoder.on('loading', function (query) {
                    instance.emit('loading', query);
                    instance.proxy.geocoderState.loading = query;
                });
                return [2 /*return*/];
        }
    });
}); };
var getGeocoderControlOptions = function (props) {
    var options = filterObject(props);
    options.accessToken = props.accessToken || mapboxgl.accessToken;
    options.mapboxgl = mapboxgl;
    return options;
};
var attachToInput = function (ref, geocoder, instance) {
    if (instance && instance.proxy) {
        if (instance.proxy.showOriginalGeocoder)
            instance.proxy.showOriginalGeocoder = false;
        // instance.setupState.showOriginalGeocoder = false;
        var inputs = ref.getElementsByTagName('input');
        if (!inputs)
            throw new Error('MapboxGeocoderControl: No inputs found');
        var input_1 = inputs[0];
        input_1.addEventListener('keyup', function (evt) {
            geocoder.query(input_1.value);
        });
    }
};

var script$g = defineComponent({
    name: 'MapboxGeocoderControl',
    props: {
        accessToken: { type: String, default: '' },
        origin: { type: String },
        zoom: { type: Number },
        flyTo: { type: [Boolean, Object], default: function () { return undefined; } },
        placeholder: { type: String },
        proximity: { type: Object },
        trackProximity: { type: Boolean, default: function () { return undefined; } },
        collapsed: { type: Boolean, default: function () { return undefined; } },
        clearAndBlurOnEsc: { type: Boolean, default: function () { return undefined; } },
        clearOnBlur: { type: Boolean, default: function () { return undefined; } },
        bbox: { type: Array },
        countries: { type: String },
        types: { type: String },
        minLength: { type: Number },
        limit: { type: Number },
        language: { type: String },
        filter: { type: Function },
        localGeocoder: { type: Function },
        externalGeocoder: { type: Function },
        // reverseMode:        { type: String as () => 'distance' | 'score' },
        reverseGeocode: { type: Boolean, default: function () { return undefined; } },
        enableEventLogging: { type: Boolean, default: function () { return undefined; } },
        marker: { type: Boolean, default: function () { return undefined; } },
        render: { type: Function },
        getItemValue: { type: Function },
        mode: { type: String },
        localGeocoderOnly: { type: Boolean, default: function () { return undefined; } }
    },
    setup: function (props) {
        var _this = this;
        var vmb_map = inject('vmb_map', null);
        var vmb_geocoder = new Deferred();
        var showOriginalGeocoder = ref(true);
        var geocoderState = ref({
            result: {},
            results: {},
            error: null,
            loading: null,
        });
        onMounted(function () { return __awaiter(_this, void 0, void 0, function () {
            var instance;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        instance = getCurrentInstance();
                        if (!instance) return [3 /*break*/, 2];
                        return [4 /*yield*/, mountGeocoderControl(vmb_map, vmb_geocoder, props, instance)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!instance) return [3 /*break*/, 4];
                        return [4 /*yield*/, mountGeocoderEvents(vmb_geocoder, instance)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        }); });
        onUnmounted(function () { return __awaiter(_this, void 0, void 0, function () {
            var geocoder, map;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, vmb_geocoder.promise];
                    case 1:
                        geocoder = _a.sent();
                        if (!vmb_map) return [3 /*break*/, 3];
                        return [4 /*yield*/, vmb_map.promise];
                    case 2:
                        map = _a.sent();
                        if (!map._removed)
                            map.removeControl(geocoder);
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); });
        watch(props, function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/];
            });
        }); });
        return { showOriginalGeocoder: showOriginalGeocoder, geocoderState: geocoderState };
    }
});

const _hoisted_1$8 = { ref: "geocoder" };
const _hoisted_2$1 = { ref: "custom-input" };

function render$g(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("div", null, [
    withDirectives(createVNode("div", _hoisted_1$8, null, 512), [
      [vShow, _ctx.showOriginalGeocoder]
    ]),
    createVNode("div", _hoisted_2$1, [
      renderSlot(_ctx.$slots, "input", {
        result: _ctx.geocoderState.result,
        results: _ctx.geocoderState.results,
        error: _ctx.geocoderState.error,
        loading: _ctx.geocoderState.loading
      })
    ], 512)
  ]))
}

script$g.render = render$g;

var conditionalWatch = (function (ref, cb, options) {
    if (ref && ref.value !== undefined)
        return watch(ref, cb, options);
    else
        return null;
});

function enableAutoResize(rootContainerRef, map, autoResizeDelay) {
    if (window.ResizeObserver) {
        enableAutoResizeWithResizeObserver(rootContainerRef, map);
    }
    else {
        var containerSize = enableAutoResizeWithEventListener(rootContainerRef, autoResizeDelay);
        watch(containerSize, function () {
            map.resize();
        });
    }
}
function enableTouchZoomRotate(map, touchZoomRotate) {
    if (touchZoomRotate.value)
        map.touchZoomRotate.enable();
    watch(touchZoomRotate, function (val) {
        if (val)
            map.touchZoomRotate.enable();
        else
            map.touchZoomRotate.disable();
    });
}
function enableAutoResizeWithResizeObserver(rootContainerRef, map) {
    if (!rootContainerRef.value)
        throw new Error('Could not enable auto-resize because root container could not be found');
    var observer = new window.ResizeObserver(function () { return map.resize(); });
    observer.observe(rootContainerRef.value);
}
function enableAutoResizeWithEventListener(watchedRef, autoResizeDelay) {
    var instance = getCurrentInstance();
    var result = reactive(new DOMRect(0, 0, 0, 0).toJSON());
    if (instance) {
        var boundingBox_1 = watchedRef.value
            ? watchedRef.value.getBoundingClientRect()
            : new DOMRect(0, 0, 0, 0);
        addEventListener('resize', function (val) {
            setTimeout(function () {
                if (watchedRef.value) {
                    var newBoundingBox = watchedRef.value.getBoundingClientRect().toJSON();
                    var boundingBoxHasChanged = boundingBox_1.width !== newBoundingBox.width || boundingBox_1.height !== newBoundingBox.height;
                    boundingBox_1 = newBoundingBox;
                    if (boundingBoxHasChanged)
                        Object.assign(result, newBoundingBox);
                }
            }, autoResizeDelay || 0);
        });
    }
    return result;
}

var getStyle = function (props) { return ({
    height: props.height,
    width: props.width,
    '--zoom-logo': props.zoomLogo >= 0.8 ? props.zoomLogo : 1,
}); };
var getMapStyle = function (raw) {
    return raw.includes('/') ? raw : "mapbox://styles/mapbox/" + raw;
};
var getMapboxOptions = function (props, el) {
    var opts = filterObject(props, [
        'accessToken',
        'antialias',
        'attributionControl',
        'bearing',
        'bearingSnap',
        'bounds',
        'boxZoom',
        'center',
        'clickTolerance',
        'collectResourceTiming',
        'container',
        'crossSourceCollisions',
        'customAttribution',
        'doubleClickZoom',
        'dragPan',
        'dragRotate',
        'fadeDuration',
        'failIfMajorPerformanceCaveat',
        'fitBoundsOptions',
        'hash',
        'interactive',
        'keyboard',
        'localIdeographFontFamily',
        'logoPosition',
        'maxBounds',
        'maxPitch',
        'maxTileCacheSize',
        'maxZoom',
        'minPitch',
        'minZoom',
        'pitch',
        'pitchWithRotate',
        'preserveDrawingBuffer',
        'refreshExpiredTiles',
        'renderWorldCopies',
        'scrollZoom',
        'touchZoomRotate',
        'trackResize',
        'transformRequest',
        'zoom',
    ]);
    opts.style = getMapStyle(props.mapStyle);
    opts.container = el;
    return opts;
};
var mountMap = function (props, vmb_map, mapContainerRef, rootContainerRef) {
    return (function () {
        var element = mapContainerRef.value;
        var mapOptions = getMapboxOptions(props, element);
        var map = new mapboxgl.Map(mapOptions);
        map.on('load', function () {
            vmb_map.resolve(map);
        });
        if (props.autoResize) {
            enableAutoResize(rootContainerRef, map, props.autoResizeDelay);
        }
        if (props.touchZoomRotate) {
            enableTouchZoomRotate(map, toRef(props, 'touchZoomRotate'));
        }
    })();
};
var updateStyle = function (props, style) {
    style.value = getStyle(props);
};
function mapWatcher(vmb_map, props, propsReactive) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, width, height, bearing, maxBounds, maxPitch, minZoom, maxZoom, minPitch, pitch, renderWorldCopies, zoom, center, flyToOptions;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = toRefs(props), width = _a.width, height = _a.height, bearing = _a.bearing, maxBounds = _a.maxBounds, maxPitch = _a.maxPitch, minZoom = _a.minZoom, maxZoom = _a.maxZoom, minPitch = _a.minPitch, pitch = _a.pitch, renderWorldCopies = _a.renderWorldCopies, zoom = _a.zoom;
                    center = propsReactive.center, flyToOptions = propsReactive.flyToOptions;
                    return [4 /*yield*/, watchDimensions(vmb_map, width, height)];
                case 1:
                    _b.sent();
                    return [4 /*yield*/, watchRegular(vmb_map, { bearing: bearing, maxBounds: maxBounds, maxPitch: maxPitch, minPitch: minPitch, pitch: pitch, renderWorldCopies: renderWorldCopies })];
                case 2:
                    _b.sent();
                    return [4 /*yield*/, watchPosition(vmb_map, { maxZoom: maxZoom, center: center, flyToOptions: flyToOptions, minZoom: minZoom, zoom: zoom })];
                case 3:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    });
}
function watchDimensions(vmb_map, width, height) {
    return __awaiter(this, void 0, void 0, function () {
        var map;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, vmb_map.promise];
                case 1:
                    map = _a.sent();
                    watch(width, function () { return map.resize(); });
                    watch(height, function () { return map.resize(); });
                    return [2 /*return*/];
            }
        });
    });
}
function watchRegular(vmb_map, refs) {
    return __awaiter(this, void 0, void 0, function () {
        var map;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, vmb_map.promise];
                case 1:
                    map = _a.sent();
                    conditionalWatch(refs.bearing, function (val) { return map.setBearing(val); });
                    conditionalWatch(refs.maxBounds, function (val) { return map.setMaxBounds(val); });
                    conditionalWatch(refs.maxPitch, function (val) { return map.setMaxPitch(val); });
                    conditionalWatch(refs.minPitch, function (val) { return map.setMinPitch(val); });
                    conditionalWatch(refs.pitch, function (val) { return map.setPitch(val); });
                    conditionalWatch(refs.renderWorldCopies, function (val) { return map.setRenderWorldCopies(val); });
                    return [2 /*return*/];
            }
        });
    });
}
function watchPosition(vmb_map, refs) {
    conditionalWatch(refs.center, function (center) { return updateMapPosition(vmb_map, { center: center }); }, { deep: true });
    conditionalWatch(refs.flyToOptions, function (flyToOptions) { return updateMapPosition(vmb_map, { flyToOptions: flyToOptions }); }, { deep: true });
    conditionalWatch(refs.maxZoom, function (maxZoom) { return updateMapPosition(vmb_map, { maxZoom: maxZoom }); });
    conditionalWatch(refs.minZoom, function (minZoom) { return updateMapPosition(vmb_map, { minZoom: minZoom }); });
    conditionalWatch(refs.zoom, function (zoom) { return updateMapPosition(vmb_map, { zoom: zoom }); });
}
function updateMapPosition(vmb_map, posProps) {
    return __awaiter(this, void 0, void 0, function () {
        var map, opts;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, vmb_map.promise];
                case 1:
                    map = _a.sent();
                    opts = posProps.flyToOptions
                        ? filterObject(posProps.flyToOptions, ['curve', 'maxDuration', 'minZoom', 'screenSpeed', 'speed'])
                        : {};
                    if (posProps.center)
                        opts.center = posProps.center;
                    if (posProps.zoom)
                        opts.zoom = posProps.zoom;
                    map.flyTo(opts);
                    return [2 /*return*/];
            }
        });
    });
}
var MapGlEvents = [
    'boxzoomstart',
    'click',
    'contextmenu',
    'data',
    'dataloading',
    'dbclick',
    'drag',
    'dragend',
    'dragstart',
    'error',
    'idle',
    'load',
    'mousedown',
    'mouseenter',
    'mouseleave',
    'mousemouve',
    'mouseout',
    'mouseover',
    'mouseup',
    'move',
    'moveend',
    'movestart',
    'pitch',
    'pitchend',
    'pitchstart',
    'remove',
    // 'render',
    'resize',
    'rotate',
    'rotateend',
    'rotatestart',
    'sourcedata',
    'sourcedataloading',
    'styledata',
    'styledataloading',
    'styleimagemissing',
    'touchcancel',
    'touchend',
    'touchstart',
    'webglcontextlost',
    'webglcontextrestored',
    'wheel',
    'zoom',
    'zoomend',
    'zoomstart'
];
var MapEmits = __spreadArrays(MapGlEvents, [
    'update:center',
    'update:flyToOptions',
    'update:zoom',
    'update:pitch',
    'update:bearing',
    'loaded'
]);
var registerMapEvents = function (vmb_map, instance) { return __awaiter(void 0, void 0, void 0, function () {
    var map;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, vmb_map.promise];
            case 1:
                map = _a.sent();
                duplicateEvents(map, instance, MapGlEvents);
                instance.emit('loaded', map);
                map.on('zoomend', function (evt) {
                    instance.emit('update:zoom', evt.target.getZoom());
                    instance.emit('update:center', evt.target.getCenter().toArray());
                });
                map.on('dragend', function (evt) {
                    instance.emit('update:center', evt.target.getCenter().toArray());
                });
                map.on('pitchend', function (evt) {
                    instance.emit('update:pitch', evt.target.getPitch());
                });
                map.on('rotateend', function (evt) {
                    instance.emit('update:bearing', evt.target.getBearing());
                });
                return [2 /*return*/];
        }
    });
}); };

var isPrimitive = function (input) {
    var primitives = ['string', 'number', 'boolean'];
    var isPrimitive = false;
    if (input === null)
        isPrimitive = true;
    if (primitives.some(function (p) { return typeof input === p; }))
        isPrimitive = true;
    return isPrimitive;
};

function vmodel (propertyValue, eventName, modelName) {
    if (eventName === void 0) { eventName = 'change'; }
    if (modelName === void 0) { modelName = 'value'; }
    var instance = getCurrentInstance();
    var eventNames = eventName instanceof Array
        ? eventName
        : [eventName];
    if (!instance)
        throw new Error('vmodel: Instance not found');
    var internal = ref(instance.props[modelName] || propertyValue);
    var _loop_1 = function (eventName_1) {
        watch(internal, function (_val) {
            instance.emit(eventName_1, internal.value);
        });
    };
    for (var _i = 0, eventNames_1 = eventNames; _i < eventNames_1.length; _i++) {
        var eventName_1 = eventNames_1[_i];
        _loop_1(eventName_1);
    }
    watch(instance.props, function () {
        if (isPrimitive(instance.props[modelName])
            ? instance.props[modelName] !== internal.value
            : !equal(instance.props[modelName], internal.value))
            internal.value = instance.props[modelName];
    });
    return internal;
}

var script$f = defineComponent({
    name: 'MapboxMap',
    emits: MapEmits,
    props: {
        accessToken: {
            type: String,
            default: undefined
        },
        height: {
            type: String,
            default: '100%'
        },
        width: {
            type: String,
            default: '100%'
        },
        container: {
            type: [Object, String] || String,
            default: ''
        },
        minZoom: {
            type: Number,
            default: 0,
        },
        maxZoom: {
            type: Number,
            default: 22,
        },
        minPitch: {
            type: Number,
            default: 0,
        },
        maxPitch: {
            type: Number,
            default: 60,
        },
        mapStyle: {
            type: [Object, String],
            default: 'mapbox://styles/mapbox/streets-v11'
        },
        hash: {
            type: Boolean,
        },
        interactive: {
            type: Boolean,
            default: true,
        },
        bearingSnap: {
            type: Number,
        },
        pitchWithRotate: {
            type: Boolean,
            default: true
        },
        clickTolerance: {
            type: Number,
        },
        attributionControl: {
            type: Boolean,
            default: true
        },
        customAttribution: {
            type: Array,
        },
        logoPosition: {
            type: String,
            default: 'bottom-left',
        },
        failIfMajorPerformanceCaveat: {
            type: Boolean,
        },
        preserveDrawingBuffer: {
            type: Boolean,
        },
        antialias: {
            type: Boolean,
        },
        refreshExpiredTiles: {
            type: Boolean,
        },
        maxBounds: {
            type: [Array, Object],
        },
        scrollZoom: {
            type: [Boolean, Object],
            default: true
        },
        boxZoom: {
            type: Boolean,
        },
        dragRotate: {
            type: Boolean,
            default: true
        },
        dragPan: {
            type: [Object, Boolean],
            default: true
        },
        keyboard: {
            type: Boolean,
        },
        doubleClickZoom: {
            type: Boolean,
        },
        touchZoomRotate: {
            type: [Boolean, Object],
            default: true
        },
        trackResize: {
            type: Boolean,
            default: true
        },
        center: {
            default: function () { return [0, 0]; },
        },
        zoom: {
            type: Number,
        },
        bearing: {
            type: Number,
        },
        pitch: {
            type: Number,
        },
        bounds: {
            type: Array,
        },
        fitBoundsOptions: {
            type: Object,
        },
        renderWorldCopies: {
            type: Boolean,
            default: true,
        },
        maxTileCacheSize: {
            type: Number,
            default: null,
        },
        localIdeographFontFamily: {
            type: String,
            default: 'sans-serif',
        },
        transformRequest: {
            type: Function,
            default: null,
        },
        collectResourceTiming: {
            type: Boolean,
            default: false,
        },
        fadeDuration: {
            type: Number,
            default: 300,
        },
        crossSourceCollisions: {
            type: Boolean,
            default: true,
        },
        zoomLogo: {
            type: Number,
            default: 1
        },
        flyToOptions: {
            default: function () { return ({}); }
        },
        autoResize: {
            type: Boolean,
            default: false
        },
        autoResizeDelay: {
            type: Number
        }
    },
    setup: function (props) {
        var root = ref(null);
        var mapContainer = ref(null);
        var vmb_map = new Deferred$1();
        provide('vmb_map', vmb_map);
        var i_center = vmodel(props, 'update:center', 'center');
        var i_flyToOptions = vmodel(props, 'update:flyToOptions', 'flyToOptions');
        var style = ref(getStyle(props));
        watch(props, function (p) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                updateStyle(p, style);
                return [2 /*return*/];
            });
        }); });
        mapWatcher(vmb_map, props, { center: i_center, flyToOptions: i_flyToOptions });
        onMounted(function () { return __awaiter(void 0, void 0, void 0, function () {
            var instance;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        instance = getCurrentInstance();
                        mapboxgl.accessToken = props.accessToken;
                        mountMap(props, vmb_map, mapContainer, root);
                        if (!instance) return [3 /*break*/, 2];
                        return [4 /*yield*/, registerMapEvents(vmb_map, instance)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
        onUnmounted(function () { return __awaiter(void 0, void 0, void 0, function () {
            var map;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, vmb_map.promise];
                    case 1:
                        map = _a.sent();
                        map.remove();
                        return [2 /*return*/];
                }
            });
        }); });
        return {
            vmb_map: vmb_map,
            root: root,
            style: style,
            i_center: i_center,
            i_flyToOptions: i_flyToOptions,
            mapContainer: mapContainer
        };
    },
});

const _withId = /*#__PURE__*/withScopeId("data-v-0a7027c4");

pushScopeId("data-v-0a7027c4");
const _hoisted_1$7 = { key: 1 };
popScopeId();

const render$f = /*#__PURE__*/_withId((_ctx, _cache, $props, $setup, $data, $options) => {
  return (openBlock(), createBlock("div", {
    style: _ctx.style,
    ref: "root",
    class: "mapbox-map"
  }, [
    (_ctx.vmb_map.isResolved)
      ? (openBlock(), createBlock("div", {
          key: 0,
          ref: "mapContainer",
          class: "map-container",
          style: { height: _ctx.height, width: _ctx.width }
        }, [
          renderSlot(_ctx.$slots, "default")
        ], 4))
      : (openBlock(), createBlock("div", _hoisted_1$7, [
          renderSlot(_ctx.$slots, "loader", {}, () => [
            createVNode("div", { style: _ctx.style }, null, 4)
          ])
        ]))
  ], 4))
});

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = "[data-v-0a7027c4] .mapboxgl-ctrl-logo {\n  zoom: var(--zoom-logo);\n}";
styleInject(css_248z);

script$f.render = render$f;
script$f.__scopeId = "data-v-0a7027c4";

var injectMap = {
    setup: function () {
        var vmb_map = inject('vmb_map', null);
        return { vmb_map: vmb_map };
    },
};

var parentIsMarker = function (instance) {
    return parentsNameIs(instance, 'MapboxMarker');
};
var getMarkerOptions = function (props) {
    return filterObject(props, [
        'element',
        'offset',
        'anchor',
        'color',
        'draggable',
        'clickTolerance',
        'rotation',
        'rotationAlignment',
        'pitchAlignment',
        'scale'
    ]);
};
var MarkerGlEvents = ['drag', 'dragend', 'dragstart'];
var MarkerEmits = __spreadArrays(MarkerGlEvents, ['update:lngLat', 'click']);
var registerMarkerEvents = function (marker, component) {
    duplicateEvents(marker, component, MarkerGlEvents);
    marker.on('dragend', function (evt) {
        return component.emit('update:lngLat', evt.target._lngLat.toArray());
    });
    marker.getElement().addEventListener('click', function (_ev) { return component.emit('click', _ev); });
};
var updateMarker = function (props, vmb_marker) { return __awaiter(void 0, void 0, void 0, function () {
    var marker, opts;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, vmb_marker.promise];
            case 1:
                marker = _a.sent();
                opts = filterObject(props);
                if (typeof opts.draggable === 'boolean')
                    marker.setDraggable(opts.draggable);
                if (opts.lngLat)
                    marker.setLngLat(opts.lngLat);
                if (opts.offset)
                    marker.setOffset(opts.offset);
                if (opts.rotation)
                    marker.setRotation(opts.rotation);
                if (opts.pitchAlignment)
                    marker.setPitchAlignment(opts.pitchAlignment);
                if (opts.rotationAlignment)
                    marker.setRotationAlignment(opts.rotationAlignment);
                return [2 /*return*/];
        }
    });
}); };
var mountMarker = function (options, vmb_map, vmb_marker, instance, lngLat, element) { return __awaiter(void 0, void 0, void 0, function () {
    var map, marker;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, vmb_map.promise];
            case 1:
                map = _a.sent();
                if (element && slotIsNotEmpty(element.value))
                    options.element = element.value;
                marker = new Marker(options)
                    .setLngLat(lngLat);
                marker.addTo(map);
                vmb_marker.resolve(marker);
                return [2 /*return*/];
        }
    });
}); };

var script$e = defineComponent({
    name: 'MapboxMarker',
    emits: MarkerEmits,
    props: {
        lngLat: {
            default: function () { return [0, 0]; },
        },
        offset: {
            type: [Array],
            default: function () { return [0, 0]; },
        },
        anchor: {
            type: String,
            default: function () { return 'bottom'; },
        },
        color: {
            type: String,
            default: '#4668F2',
        },
        scale: {
            type: Number,
            default: 1,
        },
        draggable: {
            type: Boolean,
            default: false,
        },
        rotation: {
            type: Number,
            default: 0,
        },
        pitchAlignment: {
            type: String,
            default: 'auto',
        },
        rotationAlignment: {
            type: String,
            default: 'auto',
        },
    },
    setup: function (props) {
        var _this = this;
        var vmb_map = injectMap.setup().vmb_map;
        var vmb_marker = new Deferred();
        var icon = ref(null);
        var options = getMarkerOptions(props);
        provide('vmb_marker', vmb_marker);
        onMounted(function () { return __awaiter(_this, void 0, void 0, function () {
            var instance, marker;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        instance = getCurrentInstance();
                        if (!(instance && vmb_map)) return [3 /*break*/, 3];
                        return [4 /*yield*/, mountMarker(options, vmb_map, vmb_marker, instance, props.lngLat, icon)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, vmb_marker.promise];
                    case 2:
                        marker = _a.sent();
                        registerMarkerEvents(marker, instance);
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); });
        onUnmounted(function () { return __awaiter(_this, void 0, void 0, function () {
            var marker;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, vmb_marker.promise];
                    case 1:
                        marker = _a.sent();
                        marker.remove();
                        return [2 /*return*/];
                }
            });
        }); });
        watch(props, function (p) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, updateMarker(p, vmb_marker)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
        return { icon: icon };
    },
});

const _hoisted_1$6 = { ref: "icon" };
const _hoisted_2 = { "fill-rule": "nonzero" };
const _hoisted_3 = /*#__PURE__*/createVNode("g", {
  transform: "translate(3.0, 29.0)",
  fill: "#000000"
}, [
  /*#__PURE__*/createVNode("ellipse", {
    opacity: "0.04",
    cx: "10.5",
    cy: "5.80029008",
    rx: "10.5",
    ry: "5.25002273"
  }),
  /*#__PURE__*/createVNode("ellipse", {
    opacity: "0.04",
    cx: "10.5",
    cy: "5.80029008",
    rx: "10.5",
    ry: "5.25002273"
  }),
  /*#__PURE__*/createVNode("ellipse", {
    opacity: "0.04",
    cx: "10.5",
    cy: "5.80029008",
    rx: "9.5",
    ry: "4.77275007"
  }),
  /*#__PURE__*/createVNode("ellipse", {
    opacity: "0.04",
    cx: "10.5",
    cy: "5.80029008",
    rx: "8.5",
    ry: "4.29549936"
  }),
  /*#__PURE__*/createVNode("ellipse", {
    opacity: "0.04",
    cx: "10.5",
    cy: "5.80029008",
    rx: "7.5",
    ry: "3.81822308"
  }),
  /*#__PURE__*/createVNode("ellipse", {
    opacity: "0.04",
    cx: "10.5",
    cy: "5.80029008",
    rx: "6.5",
    ry: "3.34094679"
  }),
  /*#__PURE__*/createVNode("ellipse", {
    opacity: "0.04",
    cx: "10.5",
    cy: "5.80029008",
    rx: "5.5",
    ry: "2.86367051"
  }),
  /*#__PURE__*/createVNode("ellipse", {
    opacity: "0.04",
    cx: "10.5",
    cy: "5.80029008",
    rx: "4.5",
    ry: "2.38636864"
  })
], -1);
const _hoisted_4 = /*#__PURE__*/createVNode("path", { d: "M27,13.5 C27,19.074644 20.250001,27.000002 14.75,34.500002 C14.016665,35.500004 12.983335,35.500004 12.25,34.500002 C6.7499993,27.000002 0,19.222562 0,13.5 C0,6.0441559 6.0441559,0 13.5,0 C20.955844,0 27,6.0441559 27,13.5 Z" }, null, -1);
const _hoisted_5 = /*#__PURE__*/createVNode("g", {
  opacity: "0.25",
  fill: "#000000"
}, [
  /*#__PURE__*/createVNode("path", { d: "M13.5,0 C6.0441559,0 0,6.0441559 0,13.5 C0,19.222562 6.7499993,27 12.25,34.5 C13,35.522727 14.016664,35.500004 14.75,34.5 C20.250001,27 27,19.074644 27,13.5 C27,6.0441559 20.955844,0 13.5,0 Z M13.5,1 C20.415404,1 26,6.584596 26,13.5 C26,15.898657 24.495584,19.181431 22.220703,22.738281 C19.945823,26.295132 16.705119,30.142167 13.943359,33.908203 C13.743445,34.180814 13.612715,34.322738 13.5,34.441406 C13.387285,34.322738 13.256555,34.180814 13.056641,33.908203 C10.284481,30.127985 7.4148684,26.314159 5.015625,22.773438 C2.6163816,19.232715 1,15.953538 1,13.5 C1,6.584596 6.584596,1 13.5,1 Z" })
], -1);
const _hoisted_6 = /*#__PURE__*/createVNode("g", {
  transform: "translate(6.0, 7.0)",
  fill: "#FFFFFF"
}, null, -1);
const _hoisted_7 = /*#__PURE__*/createVNode("g", { transform: "translate(8.0, 8.0)" }, [
  /*#__PURE__*/createVNode("circle", {
    fill: "#000000",
    opacity: "0.25",
    cx: "5.5",
    cy: "5.5",
    r: "5.4999962"
  }),
  /*#__PURE__*/createVNode("circle", {
    fill: "#FFFFFF",
    cx: "5.5",
    cy: "5.5",
    r: "5.4999962"
  })
], -1);

function render$e(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("div", null, [
    createVNode("div", _hoisted_1$6, [
      renderSlot(_ctx.$slots, "icon", {}, () => [
        (openBlock(), createBlock("svg", {
          display: "block",
          height: 42*_ctx.scale+'px',
          width: 27*_ctx.scale+'px',
          viewBox: "0 0 27 41"
        }, [
          createVNode("g", _hoisted_2, [
            _hoisted_3,
            createVNode("g", { fill: _ctx.color }, [
              _hoisted_4
            ], 8, ["fill"]),
            _hoisted_5,
            _hoisted_6,
            _hoisted_7
          ])
        ], 8, ["height", "width"]))
      ])
    ], 512),
    renderSlot(_ctx.$slots, "default")
  ]))
}

script$e.render = render$e;

var getNavigationControlOptions = function (props) {
    var showCompass = props.showCompass, showZoom = props.showZoom, vizualizePitch = props.vizualizePitch;
    return {
        showCompass: showCompass,
        showZoom: showZoom,
        vizualizePitch: vizualizePitch
    };
};
var mountNavigationControl = function (nav, vmb_map, position) {
    return (function () { return __awaiter(void 0, void 0, void 0, function () {
        var map;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, vmb_map.promise];
                case 1:
                    map = _a.sent();
                    map.addControl(nav, position);
                    return [2 /*return*/];
            }
        });
    }); })();
};

var script$d = defineComponent({
    name: 'MapboxNavigationControl',
    props: {
        showCompass: {
            type: Boolean,
            default: true
        },
        showZoom: {
            type: Boolean,
            default: true
        },
        visualizePitch: {
            type: Boolean,
            default: false
        },
        position: {
            type: String,
            default: function () { return 'top-right'; }
        }
    },
    setup: function (props) {
        var _this = this;
        var vmb_map = inject('vmb_map', null);
        var navOptions = getNavigationControlOptions(props);
        var vmb_navigationControl = new mapboxgl.NavigationControl(navOptions);
        var position = props.position;
        onMounted(function () {
            if (vmb_map)
                mountNavigationControl(vmb_navigationControl, vmb_map, position);
        });
        onUnmounted(function () { return __awaiter(_this, void 0, void 0, function () {
            var map;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!vmb_map) return [3 /*break*/, 2];
                        return [4 /*yield*/, vmb_map.promise];
                    case 1:
                        map = _a.sent();
                        map.removeControl(vmb_navigationControl);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
    }
});

function render$d(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("div"))
}

script$d.render = render$d;

var removeLayerIfPresent = function (id, map) {
    var layer = map.getLayer(id);
    if (layer)
        map.removeLayer(id);
};

var removeSourceIfPresent = function (id, map) {
    var source = map.getSource(id);
    if (source)
        map.removeSource(id);
};

var parentIsGeogeometry = function (instance) {
    return parentNameContains(instance, 'MapboxGeogeometry');
};
var distanceToLat = function (km) {
    return km / 110.574;
};
var distanceToLong = function (km, lat) {
    return km / (Math.cos(lat * Math.PI / 180) * 111.32);
};
var mountGeogeometry = function (vmb_map, vmb_geogeometry) { return __awaiter(void 0, void 0, void 0, function () {
    var map, geogeometry;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, vmb_map.promise];
            case 1:
                map = _a.sent();
                geogeometry = vmb_geogeometry;
                removeLayerIfPresent(geogeometry.id, map);
                removeSourceIfPresent(geogeometry.id, map);
                map.addSource(geogeometry.id, geogeometry.getGeoJSON());
                return [2 /*return*/];
        }
    });
}); };
var updateGeogeometry = function (props, vmb_map, vmb_geogeometry) { return __awaiter(void 0, void 0, void 0, function () {
    var map, geo, opts, source;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, vmb_map.promise];
            case 1:
                map = _a.sent();
                geo = vmb_geogeometry;
                opts = filterObject(props);
                source = map.getSource(geo.id);
                geo.updateOptions(opts);
                source.setData(geo.getGeoJSON().data);
                return [2 /*return*/];
        }
    });
}); };

var attachToMarker = function (instance, vmb_marker, popup) { return __awaiter(void 0, void 0, void 0, function () {
    var marker;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!vmb_marker) return [3 /*break*/, 2];
                return [4 /*yield*/, vmb_marker.promise];
            case 1:
                marker = _a.sent();
                marker.setPopup(popup);
                _a.label = 2;
            case 2: return [2 /*return*/];
        }
    });
}); };
var attachToGeogeometry = function (vmb_map, vmb_geo_paint, popup) { return __awaiter(void 0, void 0, void 0, function () {
    var paint, map, geo_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, vmb_geo_paint.promise];
            case 1:
                paint = _a.sent();
                return [4 /*yield*/, vmb_map.promise];
            case 2:
                map = _a.sent();
                if (!paint.id) return [3 /*break*/, 4];
                return [4 /*yield*/, paint.geogeometry.promise];
            case 3:
                geo_1 = _a.sent();
                map.on('click', paint.id, function (e) {
                    var coordinates = geo_1.center;
                    popup
                        .setLngLat(coordinates)
                        .addTo(map);
                });
                _a.label = 4;
            case 4: return [2 /*return*/];
        }
    });
}); };
var getPopupOptions = function (props) {
    return filterObject(props, [
        'closeButton',
        'closeOnClick',
        'closeOnMove',
        'focusAfterOpen',
        'anchor',
        'offset',
        'className',
        'maxWidth'
    ]);
};
var mountPopup = function (
// instance: ComponentInternalInstance | null,
instance, vmb_map, vmb_popup, vmb_marker, vmb_geogeometry_paint, content) { return __awaiter(void 0, void 0, void 0, function () {
    var map, popup;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, vmb_map.promise];
            case 1:
                map = _a.sent();
                popup = vmb_popup;
                popup.setDOMContent(content.value);
                if (!parentIsMarker(instance)) return [3 /*break*/, 3];
                return [4 /*yield*/, attachToMarker(instance, vmb_marker, popup)];
            case 2:
                _a.sent();
                return [3 /*break*/, 6];
            case 3:
                if (!(parentIsGeogeometry(instance) && vmb_geogeometry_paint)) return [3 /*break*/, 5];
                return [4 /*yield*/, attachToGeogeometry(vmb_map, vmb_geogeometry_paint, popup)];
            case 4:
                _a.sent();
                return [3 /*break*/, 6];
            case 5:
                popup.addTo(map);
                _a.label = 6;
            case 6: return [2 /*return*/];
        }
    });
}); };
var PopupGlEvents = ['close', 'open'];
var PopupEmits = __spreadArrays(PopupGlEvents);
var registerPopupEvents = function (vmb_popup, instance) {
    duplicateEvents(vmb_popup, instance, PopupGlEvents);
};
var updatePopup = function (props, vmb_popup) { return __awaiter(void 0, void 0, void 0, function () {
    var opts;
    return __generator(this, function (_a) {
        opts = getPopupOptions(props);
        if (opts.maxWidth)
            vmb_popup.setMaxWidth(opts.maxWidth);
        if (opts.offset)
            vmb_popup.setOffset(opts.offset);
        if (props.lngLat)
            vmb_popup.setLngLat(props.lngLat);
        return [2 /*return*/];
    });
}); };

var script$c = defineComponent({
    name: 'MapboxPopup',
    emits: PopupEmits,
    props: {
        lngLat: {
            default: function () { return [0, 0]; },
        },
        closeButton: {
            type: Boolean,
            default: false
        },
        closeOnClick: {
            type: Boolean,
            default: true
        },
        closeOnMove: {
            type: Boolean,
            default: false
        },
        anchor: {
            type: String,
            default: undefined
        },
        offset: {
            type: Number,
            default: undefined
        },
        className: {
            type: String
        },
        maxWidth: {
            type: String,
            default: '500px'
        },
        renderless: {
            type: Boolean,
            default: false,
        }
    },
    setup: function (props) {
        var _this = this;
        var content = ref(null);
        var vmb_map = inject('vmb_map', null);
        var vmb_marker = inject('vmb_marker', null);
        var vmb_paint = inject('vmb_geogeometry_paint', null);
        var popupOptions = getPopupOptions(props);
        var vmb_popup = new mapboxgl.Popup(popupOptions)
            .setLngLat(props.lngLat);
        onMounted(function () { return __awaiter(_this, void 0, void 0, function () {
            var instance;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        instance = getCurrentInstance();
                        if (!(vmb_map && instance)) return [3 /*break*/, 2];
                        return [4 /*yield*/, mountPopup(instance, vmb_map, vmb_popup, vmb_marker, vmb_paint, content)];
                    case 1:
                        _a.sent();
                        registerPopupEvents(vmb_popup, instance);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
        watch(props, function (props) {
            updatePopup(props, vmb_popup);
        });
        onUnmounted(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                vmb_popup.remove();
                return [2 /*return*/];
            });
        }); });
        return { content: content };
    }
});

const _hoisted_1$5 = { ref: "content" };

function render$c(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("div", _hoisted_1$5, [
    renderSlot(_ctx.$slots, "default")
  ], 512))
}

script$c.render = render$c;

var getAttributionControlOptions = function (props) {
    return filterObject(props);
};
var mountAttributionControl = function (vmb_map, vmb_attributionControl) { return __awaiter(void 0, void 0, void 0, function () {
    var map;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, vmb_map.promise];
            case 1:
                map = _a.sent();
                map.addControl(vmb_attributionControl);
                return [2 /*return*/];
        }
    });
}); };

var script$b = defineComponent({
    name: 'MapboxAttributionControl',
    props: {
        compact: {
            type: Boolean,
            default: false
        },
        customAttribution: {
            type: [String, Array],
            default: undefined
        }
    },
    setup: function (props) {
        var _this = this;
        var opts = getAttributionControlOptions(props);
        var vmb_attributionControl = new mapboxgl.AttributionControl(opts);
        var vmb_map = inject('vmb_map', null);
        onMounted(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (vmb_map)
                    mountAttributionControl(vmb_map, vmb_attributionControl);
                return [2 /*return*/];
            });
        }); });
        onUnmounted(function () { return __awaiter(_this, void 0, void 0, function () {
            var map;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!vmb_map) return [3 /*break*/, 2];
                        return [4 /*yield*/, vmb_map.promise];
                    case 1:
                        map = _a.sent();
                        map.removeControl(vmb_attributionControl);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
    }
});

function render$b(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("div"))
}

script$b.render = render$b;

var getScaleControlOptions = function (props) {
    var maxWidth = props.maxWidth, unit = props.unit;
    return {
        maxWidth: maxWidth,
        unit: unit
    };
};
var mountScaleControl = function (vmb_map, vmb_scaleControl) { return __awaiter(void 0, void 0, void 0, function () {
    var map;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, vmb_map.promise];
            case 1:
                map = _a.sent();
                map.addControl(vmb_scaleControl);
                return [2 /*return*/];
        }
    });
}); };

var script$a = defineComponent({
    name: 'MapboxScaleControl',
    props: {
        maxWidth: {
            type: Number,
            default: 100
        },
        unit: {
            type: String,
            default: 'metric'
        }
    },
    setup: function (props) {
        var _this = this;
        var options = getScaleControlOptions(props);
        var vmb_scaleControl = new mapboxgl.ScaleControl(options);
        var vmb_map = inject('vmb_map', null);
        onMounted(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!vmb_map) return [3 /*break*/, 2];
                        return [4 /*yield*/, mountScaleControl(vmb_map, vmb_scaleControl)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
        onUnmounted(function () { return __awaiter(_this, void 0, void 0, function () {
            var map;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!vmb_map) return [3 /*break*/, 2];
                        return [4 /*yield*/, vmb_map.promise];
                    case 1:
                        map = _a.sent();
                        map.removeControl(vmb_scaleControl);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
    }
});

function render$a(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("div"))
}

script$a.render = render$a;

var getFullscreenControlOptions = function (props) {
    return filterObject(props);
};
var mountFullscreenControl = function (vmb_fullscreenControl, vmb_map) { return __awaiter(void 0, void 0, void 0, function () {
    var map;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, vmb_map.promise];
            case 1:
                map = _a.sent();
                map.addControl(vmb_fullscreenControl);
                return [2 /*return*/];
        }
    });
}); };

var script$9 = defineComponent({
    name: 'MapboxFullscreenControl',
    props: {
        container: {
            type: Object,
            default: undefined
        }
    },
    setup: function (props) {
        var _this = this;
        var vmb_map = inject('vmb_map', null);
        var options = getFullscreenControlOptions(props);
        var vmb_fullscreenControl = new mapboxgl.FullscreenControl(options);
        onMounted(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!vmb_map) return [3 /*break*/, 2];
                        return [4 /*yield*/, mountFullscreenControl(vmb_fullscreenControl, vmb_map)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
        onUnmounted(function () { return __awaiter(_this, void 0, void 0, function () {
            var map;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!vmb_map) return [3 /*break*/, 2];
                        return [4 /*yield*/, vmb_map.promise];
                    case 1:
                        map = _a.sent();
                        map.removeControl(vmb_fullscreenControl);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
    }
});

function render$9(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("div"))
}

script$9.render = render$9;

var getDrawControlOptions = function (props) {
    return filterObject(props, ['position']);
};
var mapDrawEvents = function (vmb_map, component) {
    vmb_map.on('draw.create', function (e) {
        component.emit('create', e);
    });
    vmb_map.on('draw.update', function (e) {
        component.emit('update', e);
    });
    vmb_map.on('draw.delete', function (e) {
        component.emit('delete', e);
    });
    vmb_map.on('draw.selectionChange', function (e) {
        component.emit('selectionChange', e);
    });
};
var mountDrawControl = function (vmb_map, vmb_drawControl, opts, component) { return __awaiter(void 0, void 0, void 0, function () {
    var map;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                component.emit('loaded', vmb_drawControl);
                return [4 /*yield*/, vmb_map.promise];
            case 1:
                map = _a.sent();
                mapDrawEvents(map, component);
                map.addControl(vmb_drawControl, opts.position);
                return [2 /*return*/];
        }
    });
}); };

var script$8 = defineComponent({
    name: 'MapboxDrawControl',
    props: {
        position: {
            type: String,
            default: 'top-left'
        }
    },
    setup: function (props) {
        var _this = this;
        var opts = getDrawControlOptions(props);
        var vmb_drawControl = new MapboxDrawControl();
        var vmb_map = inject('vmb_map', null);
        onMounted(function () { return __awaiter(_this, void 0, void 0, function () {
            var component;
            return __generator(this, function (_a) {
                component = getCurrentInstance();
                if (vmb_map && component)
                    mountDrawControl(vmb_map, vmb_drawControl, opts, component);
                return [2 /*return*/];
            });
        }); });
        onUnmounted(function () { return __awaiter(_this, void 0, void 0, function () {
            var map;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!vmb_map) return [3 /*break*/, 2];
                        return [4 /*yield*/, vmb_map.promise];
                    case 1:
                        map = _a.sent();
                        map.removeControl(vmb_drawControl);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
    }
});

function render$8(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("div"))
}

script$8.render = render$8;

var script$7 = defineComponent({
    name: 'MapboxSourceGeoJson',
    props: {
        container: {
            type: Object,
            default: undefined
        }
    },
    setup: function (props) {
        var _this = this;
        var vmb_map = inject('vmb_map', null);
        new GeoJSONSource();
        onMounted(function () { return __awaiter(_this, void 0, void 0, function () {
            var map;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!vmb_map) return [3 /*break*/, 2];
                        return [4 /*yield*/, vmb_map.promise];
                    case 1:
                        map = _a.sent();
                        map.addSource;
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
    }
});

const _hoisted_1$4 = { ref: "features" };

function render$7(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("div", _hoisted_1$4, [
    renderSlot(_ctx.$slots, "default")
  ], 512))
}

script$7.render = render$7;

var getGeolocationControlOptions = function (props) {
    return filterObject(props);
};

var script$6 = defineComponent({
    name: 'MapboxGeolocateControl',
    props: {
        positionOptions: {
            type: Object,
            default: function () { return ({ enableHighAccuracy: false, timeout: 6000 }); }
        },
        fitBoundsOptions: {
            type: Object,
            default: function () { return ({ maxZoom: 15 }); }
        },
        trackUserLocation: {
            type: Boolean,
            default: false
        },
        showAccuracyCircle: {
            type: Boolean,
            default: true
        },
        showUserLocation: {
            type: Boolean,
            default: true
        }
    },
    setup: function (props) {
        var _this = this;
        var vmb_map = inject('vmb_map', null);
        var options = getGeolocationControlOptions(props);
        var vmb_geolocationControl = new mapboxgl.GeolocateControl(options);
        onMounted(function () { return __awaiter(_this, void 0, void 0, function () {
            var map;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!vmb_map) return [3 /*break*/, 2];
                        return [4 /*yield*/, vmb_map.promise];
                    case 1:
                        map = _a.sent();
                        map.addControl(vmb_geolocationControl);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
        onUnmounted(function () { return __awaiter(_this, void 0, void 0, function () {
            var map;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!vmb_map) return [3 /*break*/, 2];
                        return [4 /*yield*/, vmb_map.promise];
                    case 1:
                        map = _a.sent();
                        map.removeControl(vmb_geolocationControl);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
    }
});

function render$6(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("div"))
}

script$6.render = render$6;

var Geogeometry = /** @class */ (function () {
    function Geogeometry(input) {
        this.id = input.id;
        this.fillColor = input.fillColor || '#4668F2';
        this.antialias = typeof input.antialias === 'boolean' ? input.antialias : true;
        this.opacity = typeof input.opacity === 'number' ? input.opacity : 0.6;
        if (input.outlineColor)
            this.outlineColor = input.outlineColor;
        this.deferred = new Deferred();
        provide('vmb_geogeometry', this.deferred);
    }
    Geogeometry.prototype.updateOptions = function (input) {
        if (input.fillColor)
            this.fillColor = input.fillColor;
        if (typeof input.antialias === 'boolean')
            this.antialias = input.antialias;
        if (typeof input.opacity === 'number')
            this.opacity = input.opacity;
        if (input.outlineColor)
            this.outlineColor = input.outlineColor;
    };
    Geogeometry.prototype.getPaint = function () {
        var paint = {};
        if (this.fillColor)
            paint['fill-color'] = this.fillColor;
        if (this.antialias)
            paint['fill-antialias'] = this.antialias;
        if (this.opacity)
            paint['fill-opacity'] = this.opacity;
        if (this.outlineColor)
            paint['fill-outline-color'] = this.outlineColor;
        return paint;
    };
    Geogeometry.prototype.getLayer = function () {
        return {
            'id': this.id,
            'type': 'fill',
            'source': this.id,
            'layout': {},
            'paint': this.getPaint()
        };
    };
    return Geogeometry;
}());

var Circle = /** @class */ (function (_super) {
    __extends(Circle, _super);
    function Circle(input) {
        var _this = _super.call(this, input) || this;
        _this.edges = input.edges || 10;
        _this.radius = input.radius;
        _this.center = input.center;
        return _this;
    }
    Circle.prototype.updateOptions = function (input) {
        _super.prototype.updateOptions.call(this, input);
        if (input.edges)
            this.edges = input.edges;
        if (input.radius)
            this.radius = input.radius;
        if (input.center)
            this.center = input.center;
    };
    Circle.prototype.getGeoJSON = function () {
        var points = this.edges;
        var long = distanceToLong(this.radius, this.center[1]);
        var lat = distanceToLat(this.radius);
        var path = [];
        for (var i = 0; i < points; i++) {
            var theta = (i / points) * (2 * Math.PI);
            var x = long * Math.cos(theta);
            var y = lat * Math.sin(theta);
            path.push([this.center[0] + x, this.center[1] + y]);
        }
        path.push(path[0]);
        return {
            type: 'geojson',
            data: {
                type: 'FeatureCollection',
                features: [{
                        type: 'Feature',
                        geometry: {
                            type: 'Polygon',
                            coordinates: [path]
                        },
                        properties: {}
                    }],
            }
        };
    };
    return Circle;
}(Geogeometry));

var circlesAdded = 0;
var script$5 = defineComponent({
    name: 'MapboxGeogeometryCircle',
    props: {
        id: {
            type: String,
            default: 'circle'
        },
        center: {
            type: Array,
            required: true
        },
        radius: {
            type: Number,
            required: true
        },
        edges: {
            type: Number,
            default: 10
        },
        fillColor: {
            type: String,
        },
        outlineColor: {
            type: String,
        },
        opacity: {
            type: Number
        },
        antialias: {
            type: Boolean
        }
    },
    setup: function (props) {
        var _this = this;
        var vmb_map = inject('vmb_map', null);
        var vmb_circle = new Deferred$1();
        var id = props.id + "-" + circlesAdded++;
        var circle = new Circle(filterObject(__assign(__assign({}, props), { id: id }), [
            'id',
            'radius',
            'center',
            'edges',
            'fillColor',
            'outlineColor',
            'opacity',
            'antialias'
        ]));
        provide('vmb_circle', vmb_circle);
        onMounted(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!vmb_map) return [3 /*break*/, 2];
                        return [4 /*yield*/, mountGeogeometry(vmb_map, circle)];
                    case 1:
                        _a.sent();
                        vmb_circle.resolve(circle);
                        circle.deferred.resolve(circle);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
        watch(props, function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!vmb_map) return [3 /*break*/, 2];
                        return [4 /*yield*/, updateGeogeometry(props, vmb_map, circle)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
        onUnmounted(function () { return __awaiter(_this, void 0, void 0, function () {
            var map;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!vmb_map) return [3 /*break*/, 2];
                        return [4 /*yield*/, vmb_map.promise];
                    case 1:
                        map = _a.sent();
                        map.removeLayer(circle.id);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
    }
});

const _hoisted_1$3 = { ref: "features" };

function render$5(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_mapbox_geogeometry_fill = resolveComponent("mapbox-geogeometry-fill");

  return (openBlock(), createBlock("div", _hoisted_1$3, [
    renderSlot(_ctx.$slots, "default", {}, () => [
      createVNode(_component_mapbox_geogeometry_fill, {
        color: _ctx.fillColor,
        outlineColor: _ctx.outlineColor,
        opacity: _ctx.opacity,
        antialias: _ctx.antialias
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "popup")
        ]),
        _: 3
      }, 8, ["color", "outlineColor", "opacity", "antialias"])
    ])
  ], 512))
}

script$5.render = render$5;

var Polygon = /** @class */ (function (_super) {
    __extends(Polygon, _super);
    function Polygon(input) {
        var _this = _super.call(this, input) || this;
        _this.path = input.path;
        return _this;
    }
    Polygon.prototype.updateOptions = function (input) {
        _super.prototype.updateOptions.call(this, input);
        if (input.path)
            this.path = input.path;
    };
    Object.defineProperty(Polygon.prototype, "center", {
        get: function () {
            var sum = this.path.reduce(function (acc, c) { return [acc[0] + c[0], acc[1] + c[1]]; });
            return [sum[0] / this.path.length, sum[1] / this.path.length];
        },
        enumerable: false,
        configurable: true
    });
    Polygon.prototype.getGeoJSON = function () {
        return {
            type: 'geojson',
            data: {
                type: 'FeatureCollection',
                features: [{
                        type: 'Feature',
                        geometry: {
                            type: 'Polygon',
                            coordinates: [this.path]
                        },
                        properties: {}
                    }],
            }
        };
    };
    return Polygon;
}(Geogeometry));

var polygonsAdded = 0;
var script$4 = defineComponent({
    name: 'MapboxGeogeometryPolygon',
    props: {
        id: {
            type: String,
            default: 'polygon'
        },
        path: {
            type: Array,
            required: true
        },
        fillColor: {
            type: String,
        },
        outlineColor: {
            type: String,
        },
        opacity: {
            type: Number
        },
        antialias: {
            type: Boolean
        }
    },
    setup: function (props) {
        var _this = this;
        var vmb_map = inject('vmb_map', null);
        var vmb_polygon = new Deferred$1();
        var id = props.id + "-" + polygonsAdded++;
        var polygon = new Polygon(filterObject(__assign(__assign({}, props), { id: id }), [
            'id',
            'path',
            'fillColor',
            'outlineColor',
            'opacity',
            'antialias'
        ]));
        provide('vmb_polygon', vmb_polygon);
        onMounted(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!vmb_map) return [3 /*break*/, 2];
                        return [4 /*yield*/, mountGeogeometry(vmb_map, polygon)];
                    case 1:
                        _a.sent();
                        vmb_polygon.resolve(polygon);
                        polygon.deferred.resolve(polygon);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
        watch(props, function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!vmb_map) return [3 /*break*/, 2];
                        polygon.updateOptions(props);
                        return [4 /*yield*/, updateGeogeometry(props, vmb_map, polygon)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
        onUnmounted(function () { return __awaiter(_this, void 0, void 0, function () {
            var map;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!vmb_map) return [3 /*break*/, 2];
                        return [4 /*yield*/, vmb_map.promise];
                    case 1:
                        map = _a.sent();
                        map.removeLayer(polygon.id);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
    }
});

const _hoisted_1$2 = { ref: "features" };

function render$4(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_mapbox_geogeometry_fill = resolveComponent("mapbox-geogeometry-fill");

  return (openBlock(), createBlock("div", _hoisted_1$2, [
    renderSlot(_ctx.$slots, "default", {}, () => [
      createVNode(_component_mapbox_geogeometry_fill, {
        color: _ctx.fillColor,
        outlineColor: _ctx.outlineColor,
        opacity: _ctx.opacity,
        antialias: _ctx.antialias
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "popup")
        ]),
        _: 3
      }, 8, ["color", "outlineColor", "opacity", "antialias"])
    ])
  ], 512))
}

script$4.render = render$4;

var rotateRectangle = function (coords, angleDeg) {
    if (coords.length !== 4)
        throw 'MapboxGeogeometryRectangle.rotateRectagle: Not a rectangle. Please supply exactly four coordinates';
    var angleRad = angleDeg * Math.PI / 180;
    var rotatedCoords = [];
    for (var i = 0; i < coords.length; i++) {
        rotatedCoords.push([
            coords[i][0] * Math.cos(angleRad) - coords[i][1] * Math.sin(angleRad),
            coords[i][0] * Math.sin(angleRad) + coords[i][1] * Math.cos(angleRad)
        ]);
    }
    return rotatedCoords;
};

var Rectangle = /** @class */ (function (_super) {
    __extends(Rectangle, _super);
    function Rectangle(input) {
        var _this = _super.call(this, input) || this;
        _this.width = input.width;
        _this.height = input.height;
        _this.center = input.center;
        _this.rotationDeg = input.rotationDeg || 0;
        return _this;
    }
    Rectangle.prototype.updateOptions = function (input) {
        _super.prototype.updateOptions.call(this, input);
        if (input.width)
            this.width = input.width;
        if (input.height)
            this.height = input.height;
        if (typeof input.rotationDeg === 'number' && input.rotationDeg !== this.rotationDeg)
            this.rotationDeg = input.rotationDeg;
    };
    Object.defineProperty(Rectangle.prototype, "coordinates", {
        get: function () {
            var xy = rotateRectangle([
                [this.width / 2, this.height / 2],
                [-this.width / 2, this.height / 2],
                [-this.width / 2, -this.height / 2],
                [this.width / 2, -this.height / 2]
            ], this.rotationDeg);
            var coords = [
                [this.center[0] + distanceToLong(xy[0][0], this.center[1]), this.center[1] + distanceToLat(xy[0][1])],
                [this.center[0] + distanceToLong(xy[1][0], this.center[1]), this.center[1] + distanceToLat(xy[1][1])],
                [this.center[0] + distanceToLong(xy[2][0], this.center[1]), this.center[1] + distanceToLat(xy[2][1])],
                [this.center[0] + distanceToLong(xy[3][0], this.center[1]), this.center[1] + distanceToLat(xy[3][1])],
            ];
            return coords;
        },
        enumerable: false,
        configurable: true
    });
    Rectangle.prototype.getGeoJSON = function () {
        var path = __spreadArrays(this.coordinates, [
            this.coordinates[0]
        ]);
        return {
            type: 'geojson',
            data: {
                type: 'FeatureCollection',
                features: [{
                        type: 'Feature',
                        geometry: {
                            type: 'Polygon',
                            coordinates: [path]
                        },
                        properties: {}
                    }],
            }
        };
    };
    return Rectangle;
}(Geogeometry));

var rectanglesAdded = 0;
var script$3 = defineComponent({
    name: 'MapboxGeogeometryRectangle',
    props: {
        id: {
            type: String,
            default: 'rectangle'
        },
        center: {
            type: Array,
            required: true
        },
        width: {
            type: Number,
            required: true
        },
        height: {
            type: Number,
            required: true
        },
        fillColor: {
            type: String,
        },
        outlineColor: {
            type: String,
        },
        opacity: {
            type: Number,
            default: 0.6
        },
        antialias: {
            type: Boolean,
            default: true
        },
        rotationDeg: {
            type: Number
        }
    },
    setup: function (props) {
        var _this = this;
        var vmb_map = inject('vmb_map', null);
        var vmb_rectangle = new Deferred$1();
        var id = props.id + "-" + rectanglesAdded++;
        var rectangle = new Rectangle(filterObject(__assign(__assign({}, props), { id: id }), [
            'id',
            'width',
            'height',
            'center',
            'fillColor',
            'outlineColor',
            'opacity',
            'antialias',
            'rotationDeg'
        ]));
        provide('vmb_rectangle', vmb_rectangle);
        onMounted(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!vmb_map) return [3 /*break*/, 2];
                        return [4 /*yield*/, mountGeogeometry(vmb_map, rectangle)];
                    case 1:
                        _a.sent();
                        vmb_rectangle.resolve(rectangle);
                        rectangle.deferred.resolve(rectangle);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
        onUnmounted(function () { return __awaiter(_this, void 0, void 0, function () {
            var map;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!vmb_map) return [3 /*break*/, 2];
                        return [4 /*yield*/, vmb_map.promise];
                    case 1:
                        map = _a.sent();
                        map.removeLayer(rectangle.id);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
        watch(props, function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!vmb_map) return [3 /*break*/, 2];
                        return [4 /*yield*/, updateGeogeometry(props, vmb_map, rectangle)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
    }
});

const _hoisted_1$1 = { ref: "features" };

function render$3(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_mapbox_geogeometry_fill = resolveComponent("mapbox-geogeometry-fill");

  return (openBlock(), createBlock("div", _hoisted_1$1, [
    renderSlot(_ctx.$slots, "default", {}, () => [
      createVNode(_component_mapbox_geogeometry_fill, {
        color: _ctx.fillColor,
        outlineColor: _ctx.outlineColor,
        opacity: _ctx.opacity,
        antialias: _ctx.antialias
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "popup")
        ]),
        _: 3
      }, 8, ["color", "outlineColor", "opacity", "antialias"])
    ])
  ], 512))
}

script$3.render = render$3;

var pathIsClosed = function (pos) {
    if (pos.length <= 1)
        return false;
    else {
        return pos[0][0] === pos[pos.length - 1][0] && pos[0][1] === pos[pos.length - 1][1];
    }
};
var inputIsPath = function (potentialPath) {
    if (potentialPath.length === 0)
        return true;
    if (potentialPath[0].length === 2 && typeof potentialPath[0][0] === 'number' && typeof potentialPath[0][1] === 'number')
        return true;
    return false;
};
var getCenterForCoordinates = function (input, inputVisited, inputCenter) {
    if (inputVisited === void 0) { inputVisited = 0; }
    if (inputCenter === void 0) { inputCenter = [0, 0]; }
    var visited = inputVisited;
    var center = [inputCenter[0], inputCenter[1]];
    if (inputIsPath(input)) {
        if (pathIsClosed(input))
            input.pop();
        for (var _i = 0, _a = input; _i < _a.length; _i++) {
            var pos = _a[_i];
            center[0] = (pos[0] + center[0] * visited) / (visited + 1);
            center[1] = (pos[1] + center[1] * visited) / (visited + 1);
            visited++;
        }
    }
    else {
        for (var _b = 0, _c = input; _b < _c.length; _b++) {
            var pos = _c[_b];
            var _d = getCenterForCoordinates(pos), visitedLocal = _d.visited, centerLoacl = _d.center;
            center[0] = (center[0] * visited + centerLoacl[0] * visitedLocal) / (visitedLocal + visited);
            center[1] = (center[1] * visited + centerLoacl[1] * visitedLocal) / (visitedLocal + visited);
            visited += visitedLocal;
        }
    }
    return {
        visited: visited,
        center: center
    };
};
var getCenterForFeature = function (feature, inputVisited, inputCenter) {
    if (inputVisited === void 0) { inputVisited = 0; }
    if (inputCenter === void 0) { inputCenter = [0, 0]; }
    var visited = inputVisited;
    var center = [inputCenter[0], inputCenter[1]];
    switch (feature.geometry.type) {
        case 'Polygon':
        case 'LineString': {
            var _a = getCenterForCoordinates(feature.geometry.coordinates), centerLocal = _a.center, visitedLocal = _a.visited;
            center[0] = (center[0] * visited + centerLocal[0] * visitedLocal) / (visitedLocal + visited);
            center[1] = (center[1] * visited + centerLocal[1] * visitedLocal) / (visitedLocal + visited);
            visited += visitedLocal;
            break;
        }
    }
    return { visited: visited, center: center };
};
var getCenterForFeatureCollection = function (featureCollection, inputVisited, inputCenter) {
    if (inputVisited === void 0) { inputVisited = 0; }
    if (inputCenter === void 0) { inputCenter = [0, 0]; }
    var visited = inputVisited;
    var center = [inputCenter[0], inputCenter[1]];
    for (var _i = 0, _a = featureCollection.features; _i < _a.length; _i++) {
        var feature = _a[_i];
        var _b = getCenterForFeature(feature), centerLocal = _b.center, visitedLocal = _b.visited;
        center[0] = (center[0] * visited + centerLocal[0] * visitedLocal) / (visitedLocal + visited);
        center[1] = (center[1] * visited + centerLocal[1] * visitedLocal) / (visitedLocal + visited);
        visited += visitedLocal;
        break;
    }
    return { visited: visited, center: center };
};

var Raw = /** @class */ (function (_super) {
    __extends(Raw, _super);
    function Raw(input) {
        var _this = _super.call(this, input) || this;
        _this.source = input.source;
        return _this;
    }
    Raw.prototype.updateOptions = function (input) {
        _super.prototype.updateOptions.call(this, input);
        if (input.source)
            this.source = input.source;
    };
    Object.defineProperty(Raw.prototype, "center", {
        get: function () {
            var data = this.getGeoJSONData();
            if (!data || !data.type) {
                console.warn('Geogeometry Raw: Could not get center. Coordinates could not be obtained');
                return [0, 0];
            }
            if (data.type === 'Feature') {
                return getCenterForFeature(data).center;
            }
            if (data.type === 'FeatureCollection') {
                return getCenterForFeatureCollection(data).center;
            }
            throw new Error('Geogeometry Raw: Unknown Error getting Center');
        },
        enumerable: false,
        configurable: true
    });
    Raw.prototype.getGeoJSON = function () {
        if (this.source.type === 'geojson')
            return this.source;
        else {
            return {
                type: 'geojson',
                data: this.source
            };
        }
    };
    Raw.prototype.getGeoJSONData = function () {
        return this.getGeoJSON().data;
    };
    return Raw;
}(Geogeometry));

var rawDataAdded = 0;
var script$2 = defineComponent({
    name: 'MapboxGeogeometryRaw',
    props: {
        source: {
            type: Object,
            required: true,
        },
        id: {
            type: String,
            default: 'raw'
        },
        fillColor: {
            type: String,
            default: 'red'
        },
        outlineColor: {
            type: String,
        },
        opacity: {
            type: Number
        },
        antialias: {
            type: Boolean
        }
    },
    setup: function (props) {
        var _this = this;
        var vmb_map = inject('vmb_map', null);
        var vmb_raw = new Deferred();
        var id = props.id + "-" + rawDataAdded++;
        var raw = new Raw(filterObject(__assign(__assign({}, props), { id: id }), [
            'source',
            'id',
            'fillColor',
            'outlineColor',
            'opacity',
            'antialias'
        ]));
        provide('vmb_raw', vmb_raw);
        onMounted(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!vmb_map) return [3 /*break*/, 2];
                        return [4 /*yield*/, mountGeogeometry(vmb_map, raw)];
                    case 1:
                        _a.sent();
                        vmb_raw.resolve(raw);
                        raw.deferred.resolve(raw);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
        watch(props, function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!vmb_map) return [3 /*break*/, 2];
                        raw.updateOptions(props);
                        return [4 /*yield*/, updateGeogeometry(props, vmb_map, raw)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
        onUnmounted(function () { return __awaiter(_this, void 0, void 0, function () {
            var map;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!vmb_map) return [3 /*break*/, 2];
                        return [4 /*yield*/, vmb_map.promise];
                    case 1:
                        map = _a.sent();
                        map.removeLayer(raw.id);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
    }
});

const _hoisted_1 = { ref: "features" };

function render$2(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_mapbox_geogeometry_fill = resolveComponent("mapbox-geogeometry-fill");

  return (openBlock(), createBlock("div", _hoisted_1, [
    renderSlot(_ctx.$slots, "default", {}, () => [
      createVNode(_component_mapbox_geogeometry_fill, {
        color: _ctx.fillColor,
        outlineColor: _ctx.outlineColor,
        opacity: _ctx.opacity,
        antialias: _ctx.antialias
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "popup")
        ]),
        _: 3
      }, 8, ["color", "outlineColor", "opacity", "antialias"])
    ])
  ], 512))
}

script$2.render = render$2;

var GeogeometryPaint = /** @class */ (function () {
    function GeogeometryPaint(input) {
        this.geogeometry = input.geogeometry;
        this.deferred = new Deferred();
        provide('vmb_geogeometry_paint', this.deferred);
    }
    GeogeometryPaint.prototype._init = function (paintType, id) {
        return __awaiter(this, void 0, void 0, function () {
            var geogeometry;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.geogeometry.promise];
                    case 1:
                        geogeometry = _a.sent();
                        this.geoId = geogeometry.id;
                        this.id = this.geoId + "-" + paintType + "-" + id;
                        return [2 /*return*/];
                }
            });
        });
    };
    GeogeometryPaint.prototype.setGeoId = function (id) {
        this.geoId = id;
    };
    return GeogeometryPaint;
}());

var fillsAdded = 0;
var GeogeometryFill = /** @class */ (function (_super) {
    __extends(GeogeometryFill, _super);
    function GeogeometryFill(input) {
        var _this = _super.call(this, input) || this;
        _this.geoId = input.geoId;
        _this.id = input.geoId + "-fill-" + fillsAdded++;
        _this.color = input.color || '#4668F2';
        _this.antialias = typeof input.antialias === 'boolean' ? input.antialias : true;
        _this.opacity = typeof input.opacity === 'number' ? input.opacity : 0.6;
        if (input.outlineColor)
            _this.outlineColor = input.outlineColor;
        return _this;
    }
    GeogeometryFill.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, _super.prototype._init.call(this, 'fill', fillsAdded++)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    GeogeometryFill.prototype.getPaint = function () {
        var paint = {};
        if (this.color)
            paint['fill-color'] = this.color;
        if (this.antialias)
            paint['fill-antialias'] = this.antialias;
        if (this.opacity)
            paint['fill-opacity'] = this.opacity;
        if (this.outlineColor)
            paint['fill-outline-color'] = this.outlineColor;
        return paint;
    };
    GeogeometryFill.prototype.update = function (props, vmb_map) {
        return __awaiter(this, void 0, void 0, function () {
            var map, opts;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, vmb_map.promise];
                    case 1:
                        map = _a.sent();
                        opts = filterObject(props);
                        if (this.id) {
                            if (opts.color && opts.color !== this.color) {
                                map.setPaintProperty(this.id, 'fill-color', opts.color);
                                this.color = opts.color;
                            }
                            if (typeof opts.antialias === 'boolean' && opts.antialias !== this.antialias) {
                                map.setPaintProperty(this.id, 'fill-antialias', opts.antialias);
                                this.antialias = opts.antialias;
                            }
                            if (typeof opts.opacity === 'number' && opts.opacity !== this.opacity) {
                                map.setPaintProperty(this.id, 'fill-opacity', opts.opacity);
                                this.opacity = opts.opacity;
                            }
                            if (opts.outlineColor && opts.outlineColor !== this.outlineColor) {
                                map.setPaintProperty(this.id, 'fill-outline-color', opts.outlineColor);
                                this.outlineColor = opts.outlineColor;
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    GeogeometryFill.prototype.getLayer = function () {
        if (this.id) {
            return {
                id: this.id,
                type: 'fill',
                source: this.geoId,
                layout: {},
                paint: this.getPaint()
            };
        }
        else {
            throw new Error('Geogeometry.Paint.Fill: Cannot get layer. Not initialized');
        }
    };
    return GeogeometryFill;
}(GeogeometryPaint));

var script$1 = defineComponent({
    name: 'MapboxGeogeometryFill',
    props: {
        color: {
            type: String,
            default: '#4668F2'
        },
        antialias: {
            type: Boolean,
            default: true
        },
        opacity: {
            type: Number,
            default: 0.6
        },
        outlineColor: {
            type: String
        }
    },
    setup: function (props) {
        var _this = this;
        var vmb_geogeometry = inject('vmb_geogeometry', null);
        var vmb_fill = new Deferred();
        var vmb_map = inject('vmb_map', null);
        if (!vmb_geogeometry)
            throw new Error('MapboxGeogeometryFill: no geogeometry found as parent');
        var fill = new GeogeometryFill(__assign(__assign({}, filterObject(props)), { geogeometry: vmb_geogeometry }));
        provide('vmb_fill', vmb_fill);
        onMounted(function () { return __awaiter(_this, void 0, void 0, function () {
            var map, geogeometry;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(vmb_map && vmb_geogeometry)) return [3 /*break*/, 4];
                        return [4 /*yield*/, vmb_map.promise];
                    case 1:
                        map = _a.sent();
                        return [4 /*yield*/, vmb_geogeometry.promise];
                    case 2:
                        geogeometry = _a.sent();
                        if (!(geogeometry && map)) return [3 /*break*/, 4];
                        return [4 /*yield*/, fill.init()];
                    case 3:
                        _a.sent();
                        map.addLayer(fill.getLayer());
                        vmb_fill.resolve(fill);
                        fill.deferred.resolve(fill);
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        }); });
        watch(props, function () { return __awaiter(_this, void 0, void 0, function () {
            var fill;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, vmb_fill.promise];
                    case 1:
                        fill = _a.sent();
                        if (fill && vmb_map)
                            fill.update(props, vmb_map);
                        return [2 /*return*/];
                }
            });
        }); });
        onUnmounted(function () { return __awaiter(_this, void 0, void 0, function () {
            var map;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(vmb_map && fill.id)) return [3 /*break*/, 2];
                        return [4 /*yield*/, vmb_map.promise];
                    case 1:
                        map = _a.sent();
                        map.removeLayer(fill.id);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
        return {};
    }
});

function render$1(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("div", null, [
    renderSlot(_ctx.$slots, "default")
  ]))
}

script$1.render = render$1;

var linesAdded = 0;
var GeogeometryLine = /** @class */ (function (_super) {
    __extends(GeogeometryLine, _super);
    function GeogeometryLine(input) {
        var _this = _super.call(this, input) || this;
        _this.color = input.color || '#000';
        _this.opacity = typeof input.opacity === 'number' ? input.opacity : 0.6;
        if (input.geoId) {
            _this.geoId = input.geoId;
        }
        if (typeof input.blur === 'number')
            _this.blur = input.blur;
        if (input.cap)
            _this.cap = input.cap;
        if (input.join)
            _this.join = input.join;
        if (typeof input.width === 'number')
            _this.width = input.width;
        if (input.translate)
            _this.translate = input.translate;
        if (typeof input.offset === 'number')
            _this.offset = input.offset;
        if (input.dasharray)
            _this.dasharray = input.dasharray;
        if (typeof input.gapWidth === 'number')
            _this.gapWidth = input.gapWidth;
        if (input.gradient)
            _this.gradient = input.gradient;
        if (typeof input.miterLimit === 'number')
            _this.miterLimit = input.miterLimit;
        if (typeof input.roundLimit === 'number')
            _this.roundLimit = input.roundLimit;
        if (typeof input.sortKey === 'number')
            _this.sortKey = input.sortKey;
        if (input.translateAnchor)
            _this.translateAnchor = input.translateAnchor;
        return _this;
    }
    GeogeometryLine.prototype.getPaint = function () {
        var paintRaw = {
            'line-blur': this.blur,
            'line-cap': this.cap,
            'line-join': this.join,
            'line-opacity': this.join,
            'line-color': this.color,
            'line-width': this.width,
            'line-translate': this.translate,
            'line-offset': this.offset,
            'line-dasharray': this.dasharray,
            'line-gap-width': this.gapWidth,
            // 'line-gradient': this.gradient,
            'line-miter-limit': this.miterLimit,
            'line-round-limimt': this.roundLimit,
            'line-sort-key': this.sortKey,
            'line-translate-anchor': this.translateAnchor,
        };
        var paint = filterObject(paintRaw);
        return paint;
    };
    GeogeometryLine.prototype.init = function () {
        _super.prototype._init.call(this, 'line', linesAdded++);
        return this;
    };
    GeogeometryLine.prototype.update = function (props, vmb_map) {
        return __awaiter(this, void 0, void 0, function () {
            var map, opts;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, vmb_map.promise];
                    case 1:
                        map = _a.sent();
                        opts = filterObject(props);
                        if (this.id) {
                            if (opts.color && opts.color !== this.color) {
                                map.setPaintProperty(this.id, 'line-color', opts.color);
                                this.color = opts.color;
                            }
                            if (typeof opts.blur === 'number' && opts.blur !== this.blur) {
                                map.setPaintProperty(this.id, 'line-blur', opts.blur);
                                this.blur = opts.blur;
                            }
                            if (opts.cap && opts.cap !== this.cap) {
                                map.setPaintProperty(this.id, 'line-cap', opts.cap);
                                this.cap = opts.cap;
                            }
                            if (opts.join && opts.join !== this.join) {
                                map.setPaintProperty(this.id, 'line-join', opts.join);
                                this.join = opts.join;
                            }
                            if (typeof opts.opacity === 'number' && opts.opacity !== this.opacity) {
                                map.setPaintProperty(this.id, 'line-opacity', opts.opacity);
                                this.opacity = opts.opacity;
                            }
                            if (typeof opts.width === 'number' && opts.width !== this.width) {
                                map.setPaintProperty(this.id, 'line-width', opts.width);
                                this.width = opts.width;
                            }
                            if (opts.translate && this.translate && (opts.translate[0] !== this.translate[0] || opts.translate[1] !== this.translate[1])) {
                                map.setPaintProperty(this.id, 'line-translate', opts.translate);
                                this.translate = opts.translate;
                            }
                            if (typeof opts.offset === 'number' && this.offset !== opts.offset) {
                                map.setPaintProperty(this.id, 'line-offset', opts.offset);
                                this.offset = opts.offset;
                            }
                            if (opts.dasharray && !equal(this.dasharray, opts.dasharray)) {
                                map.setPaintProperty(this.id, 'line-dasharray', opts.dasharray);
                                this.dasharray = opts.dasharray;
                            }
                            if (typeof opts.gapWidth === 'number' && this.gapWidth !== opts.gapWidth) {
                                map.setPaintProperty(this.id, 'line-gap-width', opts.gapWidth);
                                this.gapWidth = opts.gapWidth;
                            }
                            // if(opts.gradient && this.gradient !== opts.gradient){
                            //   map.setPaintProperty(this.id, 'line-gradient', opts.gradient);
                            //   this.gradient = opts.gradient;
                            // }
                            if (typeof opts.miterLimit === 'number' && this.miterLimit !== opts.miterLimit) {
                                map.setPaintProperty(this.id, 'line-miter-limit', opts.miterLimit);
                                this.miterLimit = opts.miterLimit;
                            }
                            if (typeof opts.roundLimit === 'number' && this.roundLimit !== opts.roundLimit) {
                                map.setPaintProperty(this.id, 'line-round-limit', opts.roundLimit);
                                this.roundLimit = opts.roundLimit;
                            }
                            if (typeof opts.sortKey === 'number') {
                                map.setPaintProperty(this.id, 'line-sort-key', opts.sortKey);
                                this.sortKey = opts.sortKey;
                            }
                            if (opts.translateAnchor && this.translateAnchor !== opts.translateAnchor) {
                                map.setPaintProperty(this.id, 'line-translate-anchor', opts.translateAnchor);
                                this.translateAnchor = opts.translateAnchor;
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    GeogeometryLine.prototype.getLayer = function () {
        if (this.id) {
            return {
                id: this.id,
                type: 'line',
                source: this.geoId,
                layout: {},
                paint: this.getPaint()
            };
        }
        else {
            throw new Error('Geogeometry.Paint.Line: Cannot get Layer. Not initialized');
        }
    };
    return GeogeometryLine;
}(GeogeometryPaint));

var script = defineComponent({
    name: 'MapboxGeogeometryLine',
    props: {
        blur: {
            type: Number
        },
        cap: {
            type: String
        },
        join: {
            type: String
        },
        opacity: {
            type: Number,
            default: 1
        },
        color: {
            type: String,
            default: '#4668F2'
        },
        width: {
            type: Number
        },
        translate: {
            type: Array
        },
        offset: {
            type: Number
        },
        dasharray: {
            type: Array
        },
        gapWidth: {
            type: Number
        },
    },
    setup: function (props) {
        var _this = this;
        var vmb_geogeometry = inject('vmb_geogeometry', null);
        var vmb_line = new Deferred();
        var vmb_map = inject('vmb_map', null);
        provide('vmb_paint', vmb_line);
        if (!vmb_geogeometry)
            throw new Error('MapboxGeogeometryLine: no geogeometry found as parent');
        var line = new GeogeometryLine(__assign(__assign({}, filterObject(props)), { geogeometry: vmb_geogeometry }));
        onMounted(function () { return __awaiter(_this, void 0, void 0, function () {
            var map, geogeometry;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(vmb_map && vmb_geogeometry)) return [3 /*break*/, 4];
                        return [4 /*yield*/, line.init()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, vmb_map.promise];
                    case 2:
                        map = _a.sent();
                        return [4 /*yield*/, vmb_geogeometry.promise];
                    case 3:
                        geogeometry = _a.sent();
                        if (geogeometry && map) {
                            map.addLayer(line.getLayer());
                            vmb_line.resolve(line);
                        }
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        }); });
        watch(props, function () { return __awaiter(_this, void 0, void 0, function () {
            var line;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, vmb_line.promise];
                    case 1:
                        line = _a.sent();
                        if (line && vmb_map)
                            line.update(props, vmb_map);
                        return [2 /*return*/];
                }
            });
        }); });
        onUnmounted(function () { return __awaiter(_this, void 0, void 0, function () {
            var map;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(vmb_map && line.id)) return [3 /*break*/, 2];
                        return [4 /*yield*/, vmb_map.promise];
                    case 1:
                        map = _a.sent();
                        map.removeLayer(line.id);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
        return {};
    }
});

function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock("div"))
}

script.render = render;

// export default {
//   // MapboxGeocoder,
//   // MapboxImage,
//   // MapboxImages,
//   // MapboxLayer,
//   MapboxMap,
//   MapboxMarker,
//   // MapboxNavigationControl,
//   // MapboxPopup,
//   // MapboxSource,
//   // MapboxGeolocateControl,
//   // TestComponentInject,
//   // TestComponentProvide
// };

var components = /*#__PURE__*/Object.freeze({
    __proto__: null,
    MapboxGeocoderControl: script$g,
    MapboxMap: script$f,
    MapboxMarker: script$e,
    MapboxNavigationControl: script$d,
    MapboxPopup: script$c,
    MapboxAttributionControl: script$b,
    MapboxScaleControl: script$a,
    MapboxFullscreenControl: script$9,
    MapboxDrawControl: script$8,
    MapboxSourceGeoJson: script$7,
    MapboxGeolocateControl: script$6,
    MapboxGeogeometryCircle: script$5,
    MapboxGeogeometryPolygon: script$4,
    MapboxGeogeometryRectangle: script$3,
    MapboxGeogeometryRaw: script$2,
    MapboxGeogeometryFill: script$1,
    MapboxGeogeometryLine: script
});

// import { VueConstructor } from 'vue';
var install = (function (instance) {
    Object.keys(components).forEach(function (name) {
        instance.component(name, components[name]);
    });
});

var Animation = /** @class */ (function () {
    function Animation(data, renderFunc, opts) {
        if (opts === void 0) { opts = { speed: 1 }; }
        this.renderFunc = renderFunc;
        this.running = false;
        this.progress = 0;
        this.data = data;
        this.startTime = performance.now();
        this.speed = opts.speed;
        this.pauseTime = 0;
    }
    Animation.prototype.start = function () {
        this.startTime = performance.now() - this.progress;
        this.internalRenderFunc(this.progress);
    };
    Animation.prototype.pause = function () {
        this.pauseTime += performance.now() - this.pauseTime;
        if (this.animation)
            cancelAnimationFrame(this.animation);
    };
    Animation.prototype.reset = function () {
        this.startTime = performance.now();
        this.progress = 0;
    };
    Animation.prototype.stop = function () {
        this.pause();
        this.reset();
        this.renderFunc(this.progress, this.data);
    };
    Animation.prototype.internalRenderFunc = function (timestamp) {
        this.progress = (timestamp - this.startTime) * this.speed;
        this.renderFunc(this.progress, this.data);
        this.animation = requestAnimationFrame(this.internalRenderFunc.bind(this));
    };
    return Animation;
}());

export default install;
export { Animation, script$b as MapboxAttributionControl, script$8 as MapboxDrawControl, script$9 as MapboxFullscreenControl, script$g as MapboxGeocoderControl, script$5 as MapboxGeogeometryCircle, script$1 as MapboxGeogeometryFill, script as MapboxGeogeometryLine, script$4 as MapboxGeogeometryPolygon, script$2 as MapboxGeogeometryRaw, script$3 as MapboxGeogeometryRectangle, script$6 as MapboxGeolocateControl, script$f as MapboxMap, script$e as MapboxMarker, script$d as MapboxNavigationControl, script$c as MapboxPopup, script$a as MapboxScaleControl, script$7 as MapboxSourceGeoJson };
